import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { CalculatorConfig } from '@shared/types';
import '@shared/laadcheck.css';
import App from './App';

const mountEl = document.getElementById('laadcheck-calculator');
if (mountEl) {
  const config: CalculatorConfig = JSON.parse(
    mountEl.dataset.config ?? '{}'
  );
  createRoot(mountEl).render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}
